import auth0 from 'auth0-js'
import history from './history'

let redirectUri
if (process.env.NODE_ENV === 'development') {
  redirectUri = 'http://localhost:3000/login'
} else {
  console.log(process.env)
  if (process.env.REACT_APP_ROUTER_BASE_PATH === '/apps/oralhealth') {
    redirectUri = 'https://test.kenetto.com/apps/oralhealth/login'
  } else if (process.env.REACT_APP_LOCAL_BUILD === 'true') {
    redirectUri = 'http://localhost:5000/login'
  } else {
    redirectUri = 'https://riso.kenetto.com/demo/login'
  }
}

export default class Auth {
  login (route) {
    if (route) {
      window.localStorage.setItem('risoReturnToUrl', route)
    }
    this.auth0.authorize()
  }

  constructor () {
    this.userProfile = undefined
    this.login = this.login.bind(this)
    this.logout = this.logout.bind(this)
    this.handleAuthentication = this.handleAuthentication.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
    this.getProfile = this.getProfile.bind(this)
    this.auth0 = new auth0.WebAuth({
      domain: 'kenetto.eu.auth0.com',
      clientID: 'h5rk0IKiP6m0y7bW4Sgmf6IaysAFDF4X',
      redirectUri: redirectUri,
      responseType: 'token id_token',
      audience: 'https://api.kenetto.com',
      scope: 'openid profile email phone read:allergies'
    })
  }

  handleAuthentication () {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult)
        const route = window.localStorage.getItem('risoReturnToUrl')
        if (route) {
          history.push(route)
        } else {
          history.push('/patients')
        }
        window.localStorage.removeItem('risoReturnToUrl')
      } else if (err) {
        history.replace('/')
        console.log(err)
      }
    })
  }

  setSession (authResult) {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime())
    window.localStorage.setItem('access_token', authResult.accessToken)
    window.localStorage.setItem('id_token', authResult.idToken)
    window.localStorage.setItem('expires_at', expiresAt)
    // navigate to the home route
    history.replace('/patients')
  }

  logout () {
    // Clear Access Token and ID Token from local storage
    window.localStorage.removeItem('access_token')
    window.localStorage.removeItem('id_token')
    window.localStorage.removeItem('expires_at')
    window.localStorage.removeItem('user')
    // navigate to the home route
    history.replace('/')
  }

  getAccessToken () {
    const accessToken = window.localStorage.getItem('access_token')
    if (!accessToken) {
      throw new Error('No Access Token found')
    }
    return accessToken
  }

  getProfile (callback) {
    if (this.userProfile) {
      return this.userProfile
    } else {
      let accessToken = this.getAccessToken()
      this.auth0.client.userInfo(accessToken, (err, profile) => {
        if (profile) {
          this.userProfile = profile
        }
        callback(err, profile)
      })
    }
  }

  promisifyUserInfo (token) {
    return new Promise((resolve, reject) => {
      this.auth0.client.userInfo(token, (err, profile) => {
        if (err) {
          reject(err)
        } else {
          if (profile) {
            this.userProfile = profile
          }
          resolve(profile)
        }
      })
    })
  }

  async getProfile1 () {
    try {
      if (this.userProfile) {
        return this.userProfile
      }
      let accessToken = this.getAccessToken()
      return await this.promisifyUserInfo(accessToken)
    } catch (e) {
      return null
    }
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // Access Token's expiry time
    let expiresAt = JSON.parse(window.localStorage.getItem('expires_at'))
    return new Date().getTime() < expiresAt
  }
}



// WEBPACK FOOTER //
// ./src/Auth/Auth.js